// extracted by mini-css-extract-plugin
export default {"overlay":"jB-z","bodyOpen":"kB-z","content":"lB-z","header":"mB-z","close":"nB-z","closeNoHeading":"oB-z"};